import React, { useEffect } from "react";
import "./PropertyList.css";
import column from "../../Images/Vector (9).png";
import grid from "../../Images/Group 1171279337.png";
import grid2 from "../../Images/Group 1171279337 (1).png";
import dropdown from "../../Images/Vector (8).png";
import { useState } from "react";
import MediaSlider from "./MediaSlider";
import PropertyTable from "./PropertyTable";
import noimage from "../../Images/common_Image.jpg";
import redHeart from "../../Images/red-heart.png";
import heart from "../../Images/Vector (10).png";
import PropertyGrid from "./PropertyGrid";
import PropertyColumn from "./PropertyColumn";
import Header2 from "../../Layout/Header2";
import Header from "../../Layout/Header";
import Sidebar from "../../Layout/Sidebar";
import { GoDotFill } from "react-icons/go";
import img from "../../Images/low-angle-view-blue-white-modern-buildings-cloudy-sky 1 (1).png";
import HomeService from "../../Services/HomeService";
import { data, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import WhatsAppButton from "../../Component/WhatsAppButton";

const DeactivePropertyList = () => {
  const [properties, setProperties] = useState([]);
  const [userId, setUserId] = useState("");
  const [isClicked, setIsClicked] = useState(false);
  const [isOpenMedia, setIsOpenMedia] = useState(false);
  const [mediaArray, setMediaArray] = useState([]);

  // const location = useLocation();

  // Fetch login profile
  const fetchLoginProfile = async () => {
    try {
      const response = await HomeService.getProfile();
      setUserId(response.data?._id || "");
    } catch (error) {
      console.error("Error fetching login profile:", error);
    }
  };

  const handleClick = async (propertyId) => {
    try {
      const data = {
        userId: userId,
        propertyId: propertyId,
      };
      const res = await HomeService.addToWishList(data);
      console.log("wishlist adding status", res);

      if (res?.status) {
        toast?.success(res?.message);
        // console.log("Property added to wishlist:", res);
        // if (isClicked === true) {
        //   setIsClicked(false);
        // }
        // if (isClicked === false) {
        //   setIsClicked(true);
        // }
        fetchAllProperty();
      } else {
        console.error("Failed to add property to wishlist:", res?.message);
      }
    } catch (error) {
      console.error("Error adding property to wishlist:", error);
    }
  };

  const [loading, setLoading] = useState(false);
  // Fetch all properties
  const fetchAllProperty = async () => {
    setLoading(true);
    try {
      const response = await HomeService.getDeActiveProperties();
      console.log("new", response);
      setProperties(response?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching properties:", error);
    }
  };

  useEffect(() => {
    fetchLoginProfile();
  }, []);

  useEffect(() => {
    if (userId) {
      fetchAllProperty();
    }
  }, [userId, isClicked]);

  const handleShareClick = (property) => {
    const subject = `${property.propertytype?.propertyType} in ${property.locality?.name}`;
    const body =
      `I am interested in the ${property.propertytype?.propertyType} at ${property.address}.` +
      `%0D%0AFound information from Winners`;

    const mailtoLink = `mailto:?subject=${encodeURIComponent(
      subject,
    )}&body=${body}`;

    const link = document.createElement("a");
    link.href = mailtoLink;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openWhatsAppLink = (e, phoneNumber, textMessage) => {
    e.preventDefault();
    const isMobile =
      /iPhone|Android|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      );
    const encodedText = encodeURIComponent(textMessage);
    const link = isMobile
      ? `https://wa.me/${phoneNumber}?text=${encodedText}`
      : `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedText}`;

    // Create an <a> element and simulate a click
    const a = document.createElement("a");
    a.href = link;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.click();
  };

  const formatDateWithOrdinal = (isoDateString) => {
    const date = new Date(isoDateString);

    const day = date.getUTCDate();
    const year = date.getUTCFullYear();

    const month = date.toLocaleString("en-US", {
      month: "long",
      timeZone: "UTC",
    });

    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return "th";
      switch (n % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };

  const firstImg = (imgArray) => {
    const img =
      imgArray?.find((url) => url.match(/\.(jpg|jpeg|png|gif|webp)$/i)) ||
      noimage;
    return img;
  };

  return (
    <>
      <Header />
      <Sidebar />
      {isOpenMedia && (
        <MediaSlider
          mediaArray={mediaArray}
          onClose={() => {
            setIsOpenMedia(false);
          }}
        />
      )}
      <div className="uni_wrapper bg">
        <div className="uni_container5">
          <div className="property_list_screen_div">
            <div className="property_list_div_wrapper">
              <div className="property_grid_div">
                {loading ? (
                  <div className="property_grid_div text-center p-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading properties...</p>
                  </div>
                ) : properties.length === 0 ? (
                  <div className="no_data_message">
                    No Deactive Properties found
                  </div>
                ) : (
                  properties?.map((property, index) => (
                    <div
                      className="property_grid_one property_grid_new_class"
                      key={property._id || index}
                    >
                      <div className="propety_grid_img">
                        <img
                          className="propety_grid_img_display"
                          style={{ cursor: "pointer" }}
                          src={firstImg(property?.images)}
                          alt="Property"
                          onClick={() => {
                            setIsOpenMedia(true);
                            setMediaArray(property?.images);
                          }}
                        />

                        {/* <div
                          className="heart_div_2"
                          onClick={() => handleClick(property?.propertyId)}
                        >
                          <img
                            src={property?.isFavourite ? redHeart : heart}
                            alt="Favorite"
                          />
                        </div> */}
                        {property?.images?.length > 0 && (
                          <div
                            style={{
                              position: "absolute",
                              height: "20px",
                              borderRadius: "20px",
                              // backgroundColor: "white",
                              bottom: "5%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              left: "5%",
                              backgroundColor: "black",
                            }}
                          >
                            {property?.images?.map((e, i) => {
                              return <GoDotFill style={{ color: "white" }} />;
                            })}
                          </div>
                        )}
                      </div>
                      <div className="property_grid_data property_grid_data_new">
                        <div className="profile_row_ps">
                          {property?.name && (
                            <div className="profile_left_ps">
                              <div className="profile_avatar_ps">
                                {property?.name?.slice(0, 1)?.toUpperCase()}
                              </div>
                              <span className="profile_name_ps">
                                {property?.name}
                              </span>
                            </div>
                          )}

                          <div className="profile_right_ps">
                            <i className="fa-regular fa-calendar calendar_icon_ps"></i>
                            <span className="profile_date_ps">
                              {formatDateWithOrdinal(property?.createdOn)}
                            </span>
                          </div>
                        </div>
                        <div className="property_grid_content">
                          <div className="property_data">
                            <div className="property_para_div">
                              <p className="property_data_para">City:</p>
                              <p className="property_data_para2">
                                {property?.city.name || "N/A"}
                              </p>
                            </div>
                            <div className="property_para_div">
                              <p className="property_data_para">Locality:</p>
                              <p className="property_data_para2">
                                {property?.locality.name || "N/A"}
                              </p>
                            </div>
                            <div className="property_para_div">
                              <p className="property_data_para">BHK:</p>
                              <p className="property_data_para2">
                                {property?.bhk || "N/A"}
                              </p>
                            </div>
                          </div>
                          <div className="property_data">
                            <div className="property_para_div">
                              <p className="property_data_para">Address:</p>
                              <p className="property_data_para2">
                                {property?.address || "N/A"}
                              </p>
                            </div>
                            <div className="property_para_div">
                              <p className="property_data_para">
                                Property Type:
                              </p>
                              <p className="property_data_para2">
                                {property?.propertytype?.propertyType || "N/A"}
                              </p>
                            </div>
                            <div className="property_para_div">
                              <p className="property_data_para">Contact:</p>
                              <p className="property_data_para2">
                                {property?.phoneNo || "N/A"}
                              </p>
                            </div>
                          </div>
                          <div className="property_data">
                            <div className="property_para_div">
                              <p className="property_data_para">Area:</p>
                              <p className="property_data_para2">
                                {property?.area || "N/A"}{" "}
                                {property?.unit ? property?.unit : ""}
                              </p>
                            </div>
                            <div className="property_para_div">
                              <p className="property_data_para">Price:</p>
                              <p className="property_data_para2">
                                {property?.price || "N/A"} {property?.priceUnit}
                              </p>
                            </div>
                          </div>
                          <div className="property_data">
                            {/* <div className="property_para_div">
                              <p className="property_data_para">Floor:</p>
                              <p className="property_data_para2">
                                {property?.property?.floor || "N/A"}
                              </p>
                            </div> */}
                            {/* <div className="property_para_div">
                              <p className="property_data_para">Owner Name:</p>
                              <p className="property_data_para2">
                                {property.ownerName || "N/A"}
                              </p>
                            </div> */}
                          </div>
                        </div>
                        {/* <div className="remark_button_wrapper_div">
                          <p>Remark</p>
                          <input
                            type="text"
                            placeholder="Type something for your own use..."
                          />
                          <div className="submit_btn_icon_wrapper">
                            <button>Submit</button>
                            <div
                              className="d-flex"
                              style={{ columnGap: "12px" }}
                            >
                              
                              <div
                                className="icon_1_div"
                                style={{ cursor: "pointer" }}
                                onClick={(e) =>
                                  openWhatsAppLink(
                                    e,
                                    `91${property.phoneNo}`,
                                    `Hi ${property.ownerName}, I am interested in your ${property.propertytype?.propertyType} at ${property.address}, ${property.locality?.name}`,
                                  )
                                }
                              >
                                <img src={whatsapp} alt="WhatsApp" />
                              </div>
                              <div
                                className="icon_1_div"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleShareClick(property)}
                              >
                                <img src={arrow2} alt="Share" />
                              </div>
                            </div>
                          </div>
                        </div> */}
                      </div>
                      {/* <div className="plus_div_icon">
                        <img src={plus} alt="Add" />
                      </div> */}
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeactivePropertyList;
